<template lang="pug">
  span {{exchangerName}}
</template>

<script>
export default {
  name: 'ExchangerNames',
  props: {
    exchanges: {type: Array, required: true}
  },
  computed: {
    /**
     * 名刺交換者名を取得する
     * @returns {string}
     */
    exchangerName () {
      const exchanges = this.exchanges
      if (!exchanges || !exchanges.length || !exchanges[0].exchanger) {
        return ''
      }

      // 氏名だけ抜き出し
      let names = exchanges.map((exchange) => exchange.exchanger && exchange.exchanger.full_name)

      // unique
      names = names.filter((v, i, a) => a.indexOf(v) === i) // [...new Set(names)] でも可

      return names[0] + (names.length >= 2 ? 'ほか' : '')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/molecules/ExchangerNames.vue